import React from 'react';
import { RequiredLabel, StaticFieldLabel } from '../Label/Label';
import { Tooltip } from '../Tooltip';
import { fieldMaxWidth, StyledField, StyledFieldGroup, StyledFieldLabel, StyledHalfFieldGroup, StyledReadOnlyField, StyledSettingsField, StyledSettingsFieldHeader, StyledSettingsFieldLabel, StyledSettingsFieldSection, StyledSettingsFieldSectionContent } from './Field.styled';
export function FieldGroup(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(StyledFieldGroup, null, children);
}
export function HalfFieldGroup(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(StyledHalfFieldGroup, null, children);
}
/**
 * Composes a form input component (passed as children) with a corresponding label.
 */
export function Field(props) {
  var labelRef = React.useRef(null);
  var maxWidth = props.maxWidth || fieldMaxWidth;
  React.useEffect(function () {
    if (props.focused && labelRef.current) {
      labelRef.current.scrollIntoView();
      labelRef.current.focus();
    }
  }, [props.focused]);
  return /*#__PURE__*/React.createElement(StyledField, {
    disabled: props.disabled,
    style: {
      maxWidth: maxWidth
    }
  }, /*#__PURE__*/React.createElement(StyledFieldLabel, {
    ref: labelRef,
    htmlFor: props.htmlFor
  }, props.label, props.required && /*#__PURE__*/React.createElement(RequiredLabel, null), props.tooltip && /*#__PURE__*/React.createElement(Tooltip, null, props.tooltip)), props.children);
}
function SettingsFieldHeader(props) {
  if (props.labelAsHeading) {
    return /*#__PURE__*/React.createElement(StyledSettingsFieldHeader, {
      heading: 2
    }, props.label, props.tooltip && /*#__PURE__*/React.createElement(Tooltip, null, props.tooltip));
  }
  return /*#__PURE__*/React.createElement(StyledSettingsFieldLabel, {
    htmlFor: props.htmlFor
  }, props.label, props.tooltip && /*#__PURE__*/React.createElement(Tooltip, null, props.tooltip));
}
export function SettingsField(props) {
  return /*#__PURE__*/React.createElement(StyledSettingsField, null, /*#__PURE__*/React.createElement(SettingsFieldHeader, props), /*#__PURE__*/React.createElement(StyledSettingsFieldSection, null, /*#__PURE__*/React.createElement(StyledSettingsFieldSectionContent, null, props.children)));
}
export function ReadOnlyField(props) {
  return /*#__PURE__*/React.createElement(StyledField, {
    style: {
      maxWidth: fieldMaxWidth
    }
  }, /*#__PURE__*/React.createElement(StaticFieldLabel, {
    tooltip: props.tooltip
  }, props.label), /*#__PURE__*/React.createElement(StyledReadOnlyField, null, props.value));
}
export function getId(_ref3) {
  var htmlFor = _ref3.htmlFor;
  return htmlFor || "id".concat(Math.random());
}